import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";
import actions from "./action";
import getters from "./getters";

Vue.use(Vuex);
const state = {
  registerType: 0,
  registerStep: 0,
  findPsStep: 0,
  currentPage: "首页",
  currentNewsId: "id1",
  joinSucIs: false,
  userInfo: false,
  currentNewsDetail: "",
  user: null,
  isNoLogin: true,
  isPopTip: true,
};
export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
});
